import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/base.gjs';
import styles from './title.module.scss';

const METADATA = Metadata.define({
  description: 'Title for full-screen modal header.',
  meta: {
    title: Arg.string({ description: 'Header title' }).required(),
  },
  name: 'Title',
});

export default class SpdsModalFullScreenHeaderTitle extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-full-screen-header-title';
  styles = styles;

  <template>
    <FlexRow
      @tag="h1"
      class={{this.classes}}
      data-test-spds-modal-full-screen-header-title
      {{this.validateArguments}}
      ...attributes
    >
      {{@title}}
    </FlexRow>
  </template>
}

export const MODAL_FULL_SCREEN_HEADER_TITLE_METADATA = SpdsModalFullScreenHeaderTitle.metadata;
